<template>
	<div>
		<o-section title="Récapitulatif des signatures">
			<o-alert color="info">
				<p>
					Vous pouvez renseigner le champ <b>"Email du contact privilégié"</b> pour chacune des balances* ci-dessous.
				</p>
				<p>
					Ce faisant, <b>seule l'adresse mail renseignée aura une alerte</b> lorsque le seuil de signature est atteint
					ou lorsque le stock de signature est épuisé.
					<br>
					Vous pourrez à tout moment <b>supprimer cette adresse mail</b> afin de retrouver le fonctionnement antérieur qui notifie l'ensemble
					des administrateurs des agences concernées.
				</p>
				<p>
					<em>
						*Une balance est un regroupement d'agence qui se partage un même pack de signature.
						<br>
						Pour plus d'informations, vous pouvez contacter notre
						<a href="mailto:commercial@enso-groupe.fr">service commercial</a>
					</em>
				</p>
			</o-alert>
		</o-section>

		<o-section size="sm">
			<o-sticker
				v-for="balance in setup.newBalancies"
				:key="balance.id"
				class="sticker--signature-balance">
				<div class="balance__header">
					<h4
						class="balance__title"
						:class="setup.balanceIsLow(balance) ? 'text--warning' : 'text--info'">
						{{ setup.stickerTitle(balance) }}
						<small>
							Seuil d'alerte : {{ setup.stickerThreshold(balance) }}
						</small>
					</h4>
					<o-button
						outline
						:color="setup.balanceIsLow(balance) ? 'warning' : 'info'"
						@click="setup.orderPack(balance)">
						Commander
					</o-button>
				</div>

				<o-section>
					<o-input
						:ref="setup._interlocutor"
						v-model.trim="balance.interlocutor"
						type="email"
						label="Email du contact privilégié"/>
				</o-section>

				<h6>Agences d'emploi :</h6>
				<div class="balance__company-list">
					<o-label
						v-for="(companyName, i) in balance.companyNames"
						:key="i"
						outline>
						{{ companyName }}
					</o-label>
				</div>
			</o-sticker>
		</o-section>

		<o-section
			v-if="balancies.length > 1"
			title="Répartition">
			<div :ref="setup._signaturesChart"/>
		</o-section>

		<teleport :to="`#OrionAside-${_aside?.uid}__footer`">
			<o-section
				v-if="setup.hasChanges"
				subtitle="Des modifications n'ont pas été enregistrées">
				<o-section align="stretch">
					<o-button
						color="danger"
						outline
						@click="setup.cancel()">
						Annuler
					</o-button>
					<o-button
						:loading="setup.isLoading"
						color="success"
						outline
						@click="setup.saveAsync()">
						Enregistrer
					</o-button>
				</o-section>
			</o-section>
		</teleport>
	</div>
</template>

<script setup lang="ts">
import DashboardSignatureBalanceRepartitionAsideSetupService from '@/setup/dashboard/DashboardSignatureBalanceRepartitionAsideSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(DashboardSignatureBalanceRepartitionAsideSetupService.props);
const setup = new DashboardSignatureBalanceRepartitionAsideSetupService(props, _aside);
</script>


<style scoped lang="less">
.balance {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.3rem;
  }

  &__title {
    small {
      display: block;
      font-weight: normal;
      color: var(--grey-dark);
    }
  }

  &__company-list {
    margin: 0 -0.3rem;

    .arm-label {
      margin: 0.13rem 0.3rem;
    }
  }
}

</style>
